import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("DepositoBanco");

const otros = {
    Query: async (filtro?: models.DepositoBancoFiltro): Promise<models.DepositoBancoDTO[]> => await controller("Query", {}, filtro || {}),

    /**Contabilizar un deposito de banco */
    ContabilizarDeposito: async (entity: models.DepositoBanco): Promise<void> => await controller('ContabilizarDeposito', {}, entity),

    /**Obtiene todas las entidades  */
    Get: async (id: number): Promise<models.DepositoBancoDTO> => await controller("Get", { id }),


    Update: async (entity: models.DepositoBanco): Promise<void> => await controller('Update', {}, entity),

}

export const DepositoBanco = cacheResource({ ...otros, },
    {
    },
    {}
)


// WEBPACK FOOTER //
// ./app/resources/items/depositobanco.ts